import ProfileIcon from '../../../assets/icons/profile.png';
import LeadersIcon from '../../../assets/icons/leaders.png';
import QuestsIcon from '../../../assets/icons/quests.png';
import FriendsIcon from '../../../assets/icons/friends.png';
import PlayIcon from '../../../assets/icons/play.png';
import CloseIcon from '../../../assets/icons/close.png';
import QuizzIcon from '../../../assets/icons/quizz.png';
import HintsIcon from '../../../assets/icons/hints.png';
import HippoCointsIcon from '../../../assets/icons/hippo-coins.png';
import GoldIdIcon from '../../../assets/icons/gold-id.png';
import GoldCalendarIcon from '../../../assets/icons/gold-calendar.png';
import LeaderBoardPositionIcon from '../../../assets/icons/leaderboard-position.png';
import ReferralsIcon from '../../../assets/icons/referrals.png';
import TotalPointsIcon from '../../../assets/icons/total-points.png';
import TotalPositionIcon from '../../../assets/icons/total-position.png';
import AttemptsIcon from '../../../assets/icons/attempts.png';
import ScoreWhiteIcon from '../../../assets/icons/score-white.png';
import CopyIcon from '../../../assets/icons/copy-icon.png';
import UserIcon from '../../../assets/icons/user-icon.png';
import ScoreIcon from '../../../assets/icons/score-icon.png';
import LeaderBoardIcon from '../../../assets/icons/leaderboard-icon.png';
import Loader from '../../../assets/icons/loader.png';
import SuccessIcon from '../../../assets/icons/success-icon.png';
import ArrowRightIcon from '../../../assets/icons/arrow-right.png';
import BlueScoreIcon from '../../../assets/icons/blue-score-icon.png';
import WalletIcon from '../../../assets/icons/wallet.png';
import CompletedIcon from '../../../assets/icons/completed.png';
import WalletQuestIcon from '../../../assets/icons/wallet-quest.png';
import TelegramIcon from '../../../assets/icons/telegram.png';
import TwitterIcon from '../../../assets/icons/twitter.png';
import CaseIcon from '../../../assets/icons/case.png';
import ReferralQuestIcon from '../../../assets/icons/referral-quest.png';
import RulesIcon from '../../../assets/icons/rules-icon.png';

const Icons = {
  ProfileIcon,
  LeadersIcon,
  QuestsIcon,
  FriendsIcon,
  PlayIcon,
  CloseIcon,
  QuizzIcon,
  HintsIcon,
  HippoCointsIcon,
  GoldIdIcon,
  GoldCalendarIcon,
  LeaderBoardPositionIcon,
  ReferralsIcon,
  TotalPointsIcon,
  TotalPositionIcon,
  AttemptsIcon,
  ScoreWhiteIcon,
  CopyIcon,
  UserIcon,
  ScoreIcon,
  LeaderBoardIcon,
  Loader,
  SuccessIcon,
  ArrowRightIcon,
  BlueScoreIcon,
  WalletIcon,
  CompletedIcon,
  WalletQuestIcon,
  TelegramIcon,
  TwitterIcon,
  CaseIcon,
  ReferralQuestIcon,
  RulesIcon,
};

export type TIcons = keyof typeof Icons;
export default Icons;
